export const gasoline = [
  { title: '100LL', value: '100LL' },
  { title: 'MOGAS', value: 'MOGAS' },
  { title: 'UL91', value: 'UL91' },
  { title: 'UL94', value: 'UL94' },
  { title: '80', value: '80' },
  { title: '100', value: '100' },
  { title: '115', value: '115' },
];

export const kerosene = [
  { title: 'Jet A', value: 'A' },
  { title: 'Jet A1', value: 'A1' },
  { title: 'Jet A1+', value: 'A1+' },
  { title: 'Jet A+', value: 'A+' },
  { title: 'Jet A++', value: 'A++' },
  { title: 'Jet A++10', value: 'A++10' },
  { title: 'Jeb B', value: 'B' },
  { title: 'Jet B+', value: 'B+' },
];

export const paymentMethods = [
  { title: 'Credit card', value: 'Credit card' },
  { title: 'Debit card', value: 'Debit card' },
  { title: 'PayPal', value: 'PayPal' },
  { title: 'Wire transfer', value: 'Wire transfer' },
];
